import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Shipping() {
  return (
    <LegalPage
      title="Shipping & Delivery"
      eyebrow="DELIVERY"
      lastUpdated="January 2026"
    >
      <p>
        This page describes how digital and physical orders from{" "}
        <strong>Tapped In Clarity</strong> are delivered. Physical oracle decks
        are <strong>coming soon</strong> — once launched, the terms below will
        apply to every order.
      </p>

      <h2>1. Digital Deliveries</h2>
      <ul>
        <li>
          <strong>Albetheine Oracle App:</strong> access is granted immediately
          once your subscription is paid. The app is delivered via Expo /
          mobile install.
        </li>
        <li>
          <strong>Online Guidebook:</strong> access is granted to your account
          within minutes of payment. You will also receive a confirmation
          email.
        </li>
        <li>
          <strong>Bundle (Guidebook + 3 Months App):</strong> both products are
          unlocked immediately.
        </li>
      </ul>

      <h2>2. Psychic Medium Readings</h2>
      <p>
        Online psychic medium readings are delivered live via secure video
        link, sent to your email after booking. Sessions last 60 minutes. If
        you have any accessibility needs, please tell us at the time of
        booking.
      </p>

      <h2>3. Physical Oracle Decks — Print on Demand (Coming Soon)</h2>
      <p>
        Our Beacon and Shadow oracle decks are produced on a{" "}
        <strong>print-on-demand</strong> basis. Each deck is printed
        specifically for your order — there is no warehouse stock.
      </p>

      <h3>Production Time</h3>
      <p>
        Once printing has started, please allow approximately{" "}
        <strong>5–10 working days</strong> for production before your order is
        dispatched. Production times may be longer around launch and at busy
        seasonal periods.
      </p>

      <h3>Estimated Delivery Times</h3>
      <ul>
        <li><strong>United Kingdom:</strong> 2–5 working days after dispatch.</li>
        <li><strong>European Union:</strong> 5–12 working days after dispatch.</li>
        <li><strong>Rest of the world:</strong> 7–21 working days after dispatch.</li>
      </ul>
      <p>
        These are estimates from our print-on-demand fulfilment partner. Actual
        delivery times depend on the destination country, local couriers and
        customs.
      </p>

      <h3>Shipping Costs</h3>
      <p>
        Shipping is calculated at checkout based on the destination and the
        weight of the order. The cost shown at checkout is the total amount you
        will pay for shipping.
      </p>

      <h3>Customs, Duties &amp; Taxes</h3>
      <p>
        For deliveries outside the United Kingdom, the recipient may be
        responsible for import duties, taxes and any customs handling fees.
        These are not included in the product price or shipping cost.
      </p>

      <h3>Tracking</h3>
      <p>
        Where the chosen shipping option supports tracking, a tracking link
        will be emailed to you when your deck is dispatched.
      </p>

      <h3>Lost or Delayed Orders</h3>
      <p>
        If your order has not arrived within the estimated delivery window plus
        10 working days, please contact us at{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>{" "}
        with your order number. We will investigate with the courier and, where
        appropriate, arrange a reprint or refund.
      </p>

      <h3>Incorrect Addresses</h3>
      <p>
        It is your responsibility to provide a correct delivery address. If a
        deck is returned to us because of an incorrect or incomplete address,
        you will be responsible for the cost of re-sending the order.
      </p>

      <h2>4. Damaged or Faulty Items</h2>
      <p>
        See our <a href="/refund">Refund Policy</a> for the process to report a
        damaged or faulty deck within 14 days of delivery.
      </p>
    </LegalPage>
  );
}
